import { render, staticRenderFns } from "./omsetarea_list.vue?vue&type=template&id=1e4c8264"
import script from "./omsetarea_list.vue?vue&type=script&lang=js"
export * from "./omsetarea_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports